/* Sarvati product reel. 21 September 2026.
   The button carries the video's addresses; nothing downloads until it is
   tapped. Which copy plays:
     1. the HLS stream (data-reel-hls) on browsers that play it natively
        (iPhone and iPad Safari): adaptive, so it sends what the connection
        can take;
     2. otherwise the 720p mp4, whose address Shopify derives from the
        1080p one; it is checked with a HEAD request first;
     3. otherwise the 1080p mp4 (data-reel-url), or the old pasted URL.
   The 1080p to 720p name pairs: 7.2 to 4.5 and 4.8 to 3.0 Mbps are the
   original uploads, 2.5 to 1.6 Mbps the compressed re-uploads. */
(function () {
  if (window.SarvatiProductReelLoaded) return;
  window.SarvatiProductReelLoaded = true;

  function pick(trigger) {
    var mp4 = trigger.dataset.reelUrl || '';
    var hls = trigger.dataset.reelHls || '';
    var probe = document.createElement('video');
    if (hls && probe.canPlayType('application/vnd.apple.mpegurl')) return Promise.resolve(hls);
    var cand = mp4.replace('HD-1080p-7.2Mbps', 'HD-720p-4.5Mbps').replace('HD-1080p-4.8Mbps', 'HD-720p-3.0Mbps').replace('HD-1080p-2.5Mbps', 'HD-720p-1.6Mbps');
    if (cand === mp4 || cand.indexOf('//') === -1) return Promise.resolve(mp4);
    return fetch(cand, { method: 'HEAD' }).then(function (r) { return r.ok ? cand : mp4; }).catch(function () { return mp4; });
  }

  function closeReel(root) {
    var modal = root.querySelector('[data-reel-modal]');
    var video = root.querySelector('[data-reel-video]');
    if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
    if (modal) modal.hidden = true;
    document.documentElement.classList.remove('sarvati-reel-open');
  }

  function openReel(root, trigger) {
    var modal = root.querySelector('[data-reel-modal]');
    var video = root.querySelector('[data-reel-video]');
    if (!modal || !video) return;
    modal.hidden = false;
    document.documentElement.classList.add('sarvati-reel-open');
    pick(trigger).then(function (url) {
      if (!url) return;
      video.src = url;
      video.play().catch(function () {});
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sarvati-reel] .sarvati-reel__trigger');
    if (trigger) { openReel(trigger.closest('[data-sarvati-reel]'), trigger); return; }
    var closeButton = event.target.closest('[data-reel-close]');
    if (closeButton) closeReel(closeButton.closest('[data-sarvati-reel]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-sarvati-reel]').forEach(closeReel);
  });
})();